import { transaction } from "mobx";

export default class Menu {
  constructor(makeMobxStore, _) {
    this._ = _;
    this.reset = makeMobxStore(this);
  }
  set = {
    anchor: anchor => {
      this.anchor = anchor;
    },
    anchorId: anchorId => {
      this.anchorId = anchorId;
    },
    Component: (Component = () => null) => {
      this.Component = Component;
    },
    sx: (sx = {}) => {
      this.sx = sx;
    },
    options: (
      options = {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        }
      }
    ) => {
      this.options = options;
    },
    state: state => {
      this.state = state;
    }
  };
  get open() {
    return this.anchor !== undefined || this.anchorId !== undefined;
  }
  // helpers
  configure = config => {
    transaction(() => {
      this.reset();

      for (const setting in config) {
        this.set[setting](config[setting]);
      }
    });
  };
  close = () => {
    this.set.anchor();
    this.set.anchorId();
  };
}
